import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Loader from '../../features/common/Loader/Loader';
import { useAppDispatch, useAppSelector } from '../../hooks/storeHooks';
import TableHeader from '../data-tables/TableHeader';
import { fetchInitialStateAsync } from '../../features/asset-status/AssetStatusSlice';
import RodLiftStatusOverviewTable from './RodLiftStatusOverviewTable';

const RodLiftStatusOverView: React.FC = () => {
  const dispatch = useAppDispatch();
  const { assetId } = useParams<{ assetId: string }>();
  const isRodliftwellStatusLoading = useAppSelector((state: any) => state.rodliftwellstatus?.loading ?? false);
  const rodliftwellstatusData = useAppSelector((state: any) => state.rodliftwellstatus?.data?.statusRegisters ?? []);

  const getAssetStatusData = () => {
    if (assetId) {
      dispatch(fetchInitialStateAsync({ assetId }));
    }
  };

  useEffect(() => {
    getAssetStatusData();
  }, [assetId]);

  return (
    <main className='main-container table-wrap'>
      <TableHeader title='Status Registers' />
      {isRodliftwellStatusLoading ? (
        <div className='flex justify-center items-center py-10'>
          <Loader />
        </div>
      ) : rodliftwellstatusData.length > 0 ? (
        <RodLiftStatusOverviewTable data={rodliftwellstatusData} />
      ) : (
        <div className='no-matching-records-container text-center p-4 pl-6 pr-6'>
          <span className='no-matching-records-message'>No records found</span>
        </div>
      )}
    </main>
  );
};

export default RodLiftStatusOverView;
